import { Grid, Stack } from '@mui/material';
import {
  Navigate,
  useNavigate,
  useParams,
  useSearchParams,
} from 'react-router';
import { PageContainer } from '@/components/shared/page-container';
import { PageHeader } from '@/components/shared/page-header';
import { PageSkeleton } from '@/components/shared/page-skeleton';
import { useAcademicSituationShow } from '@/data/learning/academic-situation';
import { useSetTitle } from '@/hooks/use-set-title';
import { AcademicStatusForm } from '@/packages/academic-hub/components/academic-status-form';
import { AcademicSituationSummary } from '@/packages/academic-hub/components/academic-situation-summary';
import { AcademicTimeline } from '@/packages/academic-hub/components/academic-timeline';

export const AcademicSituationDetails = () => {
  useSetTitle('Hub Acadêmico');
  const navigate = useNavigate();
  const { id = '' } = useParams();
  const [searchParams] = useSearchParams();
  const { academicSituation, isLoading } = useAcademicSituationShow(id);

  const goBack = () => navigate('/hub-academico');

  if (isLoading) return <PageSkeleton />;

  if (!academicSituation) {
    return <Navigate to="/hub-academico" replace />;
  }

  return (
    <PageContainer>
      <PageHeader
        backNavigationText="Hub Acadêmico"
        handleBackNavigation={goBack}
      />
      <Grid container spacing={3} mt={0}>
        <Grid size={{ xs: 12, md: 5 }}>
          <AcademicSituationSummary situation={academicSituation} />
        </Grid>
        <Grid size={{ xs: 12, md: 7 }}>
          <Stack spacing={3}>
            <AcademicStatusForm
              situation={academicSituation}
              defaultExpanded={searchParams.get('expand') === 'status'}
            />
            <AcademicTimeline situation={academicSituation} />
          </Stack>
        </Grid>
      </Grid>
    </PageContainer>
  );
};
